<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb61></breadcrumb61>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>

                <div class="col-md-6 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>

                <div class="col-md-6 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <!-- Basic Information -->
                  <div class="col-md-12 ml-md-3">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="background-color: #F8F8F8;" class="text-left">Name</th>
                          <th style="background-color: #F8F8F8;" class="text-left">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in hospital_list_data" :key="index" v-bind:key="index"
                          v-show="setPaginate(index)">
                          <td class="text-left">
                            {{ hospital_list_data[index].name_of_hospital }}
                          </td>
                          <td class="text-left">
                            {{ hospital_list_data[index].address }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <h5 v-if="hospital_list_data.length === 0 && !showspinner
                      " class="No_data">
                      No Excercise Plane Found
                    </h5>
                    <!-- pagination start -->
                    <div id="pagination" v-if="hospital_list_data.length > 10">
                      <ul class="pagination justify-content-center">

                        <!-- "Previous" Button -->
                        <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                          <a href="#" class="page-link" aria-label="Previous"
                            @click.prevent="updateHospitalCount(current - 1)">
                            Previous
                          </a>
                        </li>

                        <!-- Pagination Links (Display 5 at a time) -->
                        <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                          'page-item',
                          current === page_index ? 'active' : ''
                        ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                          <a href="#" class="page-link" @click.prevent="updateHospitalCount(page_index)">
                            {{ page_index }}
                          </a>
                        </li>

                        <!-- "Next" Button -->
                        <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                          ">
                          <a href="#" class="page-link" aria-label="Next"
                            @click.prevent="updateHospitalCount(current + 1)">
                            Next
                          </a>
                        </li>
                      </ul>
                    </div>
                    <!-- pagination end -->
                  </div>

                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showspinner: false,
      hospital_list_data: [],

      current: 1,
      paginate: 10,
      paginate_total: 0,
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {

    //pagination start
    updateHospitalCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end


    //edit exercise plans
    edit_plan_details(id) {
      this.$router.push(`/doctor/edit-exercise-plan/${id}`);
    },
    /* Get All Excercise Plane Details */


    /* Get All General Advice Template Plan   */
    async get_hospitals_list_data() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.api.get_hospitals",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.hospital_list_data = res.data;
          this.paginate_total = Math.ceil(
            this.hospital_list_data.length / this.paginate
          );
        }
      });
    },
  },
  mounted() {
    this.get_hospitals_list_data();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/kneexpert/doctor/HospitalList.vue